
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import { createInternalProfile } from '@/Services/web/InternalProfileService'

import useTranslation from '@/Hooks/UseTranslation'
import { useTeams } from '@/Hooks/UseTeam'
import { useProject } from '@/Hooks/UseProject'

import Modal from '@/Components/Modal/Modal'
import InputFormControl from '@/Components/InputFormControl/InputFormControl'
import InputSelect from '@/Components/ProgrammationManager/components/InputSelect'

import AddICon from '@/Components/SvgImages/Add'

import './InternalProfilesCreator.scss'
import Button from '@/Components/Button/Button'

interface Props {
  show: boolean
  onHide: () => void
}

const InternalProfilesCreator = (props: Props) => {

  const { show, onHide } = props

  const { t } = useTranslation()

  const { users, teamSelected, addInternalProfile } = useTeams()
  const { project } = useProject()

  const [ name, setName ] = useState('')
  const [ surname, setSurname ] = useState('')
  const [ email, setEmail ] = useState('')
  const [ company, setCompany ] = useState('')
  const [ responsible, setResponsible ] = useState('')
  const [ creating, setCreating ] = useState(false)

  const handleAddInternalProfile = async () => {

    if (!name || !surname || !responsible) return

    setCreating(true)

    const body = {
      project: project._id,
      team: teamSelected._id,
      responsible,
      name,
      surname,
      email,
      company,
    }

    const [ err, data ] = await createInternalProfile(body)

    setCreating(false)

    if (err) return console.log(err)

      const { internalProfile } = data

      internalProfile.responsible = users.find((u: any) => u._id === responsible)

    addInternalProfile(internalProfile)

    handleLeave()
  }

  const handleLeave = () => {

    setName('')
    setSurname('')
    setEmail('')
    setCompany('')
    setResponsible('')

    onHide()
  }

  return (
    <Modal
      show={show}
      title={t('INTERNAL_PROFILE_CREATOR:Title')}
      onClose={handleLeave}
      size='sm'
      showCloseButton={true}
      backdropClassName='internal-profiles-creator-backdrop'
      className="internal-profiles-creator"
    >
      <div className="form-group">
        <label htmlFor="name">{t('INTERNAL_PROFILE_CREATOR:Name')}</label>
        <InputFormControl
          placeholder={t('INTERNAL_PROFILE_CREATOR:Email')}
          value={name}
          onChange={setName}
          type="text"
          />
      </div>
      <div className="form-group">
        <label htmlFor="surname">{t('INTERNAL_PROFILE_CREATOR:Surname')}</label>
        <InputFormControl
          placeholder={t('INTERNAL_PROFILE_CREATOR:Surname')}
          value={surname}
          onChange={setSurname}
          type="text"
          />
      </div>
      <div className="form-group">
        <label htmlFor="email">{t('INTERNAL_PROFILE_CREATOR:Email')}</label>
        <InputFormControl
          placeholder={t('INTERNAL_PROFILE_CREATOR:Email')}
          value={email}
          onChange={setEmail}
          type="email"
        />
      </div>
      <div className="form-group">
        <label htmlFor="company">{t('INTERNAL_PROFILE_CREATOR:Company')}</label>
        <InputFormControl
          placeholder={t('INTERNAL_PROFILE_CREATOR:Company')}
          value={company}
          onChange={setCompany}
          type="text"
        />
      </div>
      <div className="form-group">
        <label htmlFor="responsible">{t('INTERNAL_PROFILE_CREATOR:Responsible')}</label>
        <InputSelect
          value={responsible}
          options={users.map((u: any) => ({ _id: u._id, name: `${u.name} (${u.surname})` }))}
          onChange={setResponsible}
          placeholder={`${t('INTERNAL_PROFILE_CREATOR:SelectUser')}...`}
        />
      </div>
      <Row>
        <Col style={{ textAlign: 'right' }}>
          <Button
            variant='primary'
            onClick={() => handleAddInternalProfile()}
            disabled={!name || !surname || !responsible}
          >
            <AddICon fill="#fff" height={24} width={24} />{' '}
            {!creating && t('INTERNAL_PROFILE_CREATOR:AddButton')}
            {creating && t('INTERNAL_PROFILE_CREATOR:AddButtonAdding')}
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}

export default InternalProfilesCreator
